var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRevealFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.901 11.943c0-1.625-1.288-2.953-2.878-2.953-1.583 0-2.877 1.328-2.877 2.953 0 1.624 1.294 2.952 2.877 2.952 1.584 0 2.878-1.328 2.878-2.952Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.97 18.845h.06c6.918 0 11.445-6.154 11.636-6.417l.335-.465-.335-.472C23.476 11.22 18.948 5 12.03 5h-.06C5.053 5 .527 11.228.336 11.49L0 11.964l.335.465c.19.263 4.717 6.416 11.636 6.416Zm-4.362-6.902c0-2.501 1.978-4.53 4.415-4.53 2.438 0 4.415 2.029 4.415 4.53 0 2.5-1.977 4.529-4.415 4.529-2.437 0-4.415-2.029-4.415-4.53Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRevealFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/RevealFilled.7a4989046a6713eab6712a6f1dcc159e.svg";